import React, { useEffect, useState } from "react";
import { fetchExperienceTripslist } from "../services/ExperienceTripslist";
import { API_BASE } from "../api/apiConfig";

const ExperienceTripslist = () => {
  const [meetups, setMeetups] = useState([]);
  const [filteredMeetups, setFilteredMeetups] = useState([]);

  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("All");
  const [city, setCity] = useState("All");
  const [viewMode, setViewMode] = useState("all"); // all | city
  const [loading, setLoading] = useState(true);

  /* ================= API LOAD ================= */
  useEffect(() => {
    loadMeetups();
  }, []);

  const loadMeetups = async () => {
    try {
      const res = await fetchExperienceTripslist();
      if (res?.status) {
        setMeetups(res.data);
        setFilteredMeetups(res.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  /* ================= FILTER LOGIC ================= */
  useEffect(() => {
    let data = [...meetups];

    if (search) {
      data = data.filter(
        (item) =>
          item.heading.toLowerCase().includes(search.toLowerCase()) ||
          item.city.toLowerCase().includes(search.toLowerCase())
      );
    }

    if (category !== "All") {
      data = data.filter((item) =>
        JSON.parse(item.category).includes(category)
      );
    }

    if (city !== "All") {
      data = data.filter((item) => item.city === city);
    }

    setFilteredMeetups(data);
  }, [search, category, city, meetups]);

  if (loading) {
    return <p className="text-center py-10">Loading ExperienceTrips...</p>;
  }

  const formatDate = (date) => {
    if (!date) return "";
    return new Date(date).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
     <section className="py-8 md:py-16">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-6 md:mb-10 text-center">
          <h2 className="text-lg md:text-2xl lg:text-3xl font-bold text-slate-900">
            Signature Journeys
          </h2>
          <p className="text-slate-600 text-xs md:text-sm mt-0.5 md:mt-1">
            Curated experiences led by Travel Experts
          </p>
        </div>
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
  
        {filteredMeetups.map((item) => (
            <a
              className="group block"
              href={`/ExperienceTripsDtl/${item.id}`}
            >
              <div className="relative h-[280px] md:h-[340px] lg:h-[380px] rounded-2xl overflow-hidden">
                <img
                  alt={item.city}
                  loading="lazy"
                  decoding="async"
                  data-nimg="fill"
                  className="object-cover transition-transform duration-700 group-hover:scale-105"
                  style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    left: 0,
                    top: 0,
                    right: 0,
                    bottom: 0,
                    color: "transparent"
                  }}
                  src={`${API_BASE}/${item.images}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />
                <div className="absolute top-3 right-3 md:top-4 md:right-4">
                  <span className="inline-flex items-center gap-1 bg-white/95 backdrop-blur-sm text-slate-800 text-[10px] md:text-xs font-medium px-2 py-1 md:px-2.5 md:py-1 rounded-full">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-lightbulb h-3 w-3 text-primary"
                    >
                      <path d="M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5" />
                      <path d="M9 18h6" />
                      <path d="M10 22h4" />
                    </svg>
                    {item.tage}
                  </span>
                </div>
                <div className="absolute inset-0 p-4 md:p-5 flex flex-col justify-end">
                  <div className="flex items-center gap-1.5 md:gap-2 text-white/60 text-xs md:text-sm mb-1.5 md:mb-2">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={24}
                      height={24}
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth={2}
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="lucide lucide-calendar h-3 w-3 md:h-3.5 md:w-3.5"
                    >
                      <rect width={18} height={18} x={3} y={4} rx={2} ry={2} />
                      <line x1={16} x2={16} y1={2} y2={6} />
                      <line x1={8} x2={8} y1={2} y2={6} />
                      <line x1={3} x2={21} y1={10} y2={10} />
                    </svg>
                    <span>{formatDate(item.expdate)}</span>
                    <span className="mx-0.5 md:mx-1">·</span>
                    <span>{item.no_of_days} Days</span>
                  </div>
                  <h3 className="text-sm md:text-lg font-bold text-white mb-2 md:mb-3 leading-tight line-clamp-2">
                    {item.name}
                  </h3>

              {item.local_experts_details && item.local_experts_details.length > 0 && (
                  <div className="flex items-center gap-2 md:gap-3 pt-2 md:pt-3 border-t border-white/20">
                    <div className="relative h-7 w-7 md:h-9 md:w-9 rounded-full overflow-hidden border-2 border-white/40 flex-shrink-0">
                      <img
                        alt={item.local_experts_details[0].name}
                        loading="lazy"
                        decoding="async"
                        data-nimg="fill"
                        className="object-cover"
                        style={{
                          position: "absolute",
                          height: "100%",
                          width: "100%",
                          left: 0,
                          top: 0,
                          right: 0,
                          bottom: 0,
                          color: "transparent"
                        }}
                        src={`${API_BASE}/${item.local_experts_details[0].profile_image}`}
                      />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-white text-xs md:text-sm font-medium truncate">
                        {item.local_experts_details[0].name}
                      </p>
                      {/*<p className="text-white/60 text-[10px] md:text-xs truncate">
                        AI Strategist &amp; Prompt Engineer
                      </p>*/}
                    </div>
                  </div>
              )}
                </div>
              </div>
            </a>
        ))}

          </div>
        </div>
      </div>
    </section>

  );
};

export default ExperienceTripslist;
